import {
  canAccessEquipmentAttachment,
  type Actor,
} from 'domains-work-order-authorization';
import {
  getAttachmentAccess,
  type AttachmentAccess,
} from './getAttachmentAccess';
import {
  toEquipmentResource,
  type EquipmentRecord,
} from './toEquipmentResource';

interface EquipmentAttachmentAccessRequest {
  actor: Actor;
  record: EquipmentRecord;
  isEnforced: boolean;
}

export const getEquipmentAttachmentAccess = ({
  actor,
  record,
  isEnforced,
}: EquipmentAttachmentAccessRequest): AttachmentAccess =>
  getAttachmentAccess({
    actor,
    resource: toEquipmentResource(record),
    isEnforced,
    canAccess: canAccessEquipmentAttachment,
  });
